import React from 'react';  

const InputFieldWithIcon = ({ placeholder, onchange, icon, paramkey, type }) => {  

    const handleChange = (e) => {
        if(onchange)
            onchange(e);    
    };

    return (  
        <div className="relative">  
            <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500">  
                {icon}
            </span>  
            <input  
                type={type ? type : "text"}    
                onChange={handleChange}  
                placeholder={placeholder}  
                className="block w-full h-10 pl-10 pr-4  bg-thirdly border border-gray-500/100 rounded-md "  
            />  
        </div>  
    );  
};  

export default InputFieldWithIcon;